import LessonReviewApiUtils from '../utils/api/lessonReview';
import { addMessage as addModalMessage, hide as hideModal } from './modal';
import { addMessage as addFlashMessage } from './flash';

export const FETCH_LESSON_REVIEWS_BY_TUTOR_SENT =
  'FETCH_LESSON_REVIEWS_BY_TUTOR_SENT';
export const FETCH_LESSON_REVIEWS_BY_TUTOR_SUCCEEDED =
  'FETCH_LESSON_REVIEWS_BY_TUTOR_SUCCEEDED';
export const FETCH_LESSON_REVIEWS_BY_TUTOR_FAILED =
  'FETCH_LESSON_REVIEWS_BY_TUTOR_FAILED';
export const CREATE_LESSON_REVIEW_SENT = 'CREATE_LESSON_REVIEW_SENT';
export const CREATE_LESSON_REVIEW_SUCCEEDED = 'CREATE_LESSON_REVIEW_SUCCEEDED';
export const CREATE_LESSON_REVIEW_FAILED = 'CREATE_LESSON_REVIEW_FAILED';

export function fetchByTutorSent() {
  return { type: FETCH_LESSON_REVIEWS_BY_TUTOR_SENT };
}

export function fetchByTutorSucceeded(data) {
  return {
    type: FETCH_LESSON_REVIEWS_BY_TUTOR_SUCCEEDED,
    payload: data,
  };
}

export function fetchByTutorFailed(error) {
  return {
    type: FETCH_LESSON_REVIEWS_BY_TUTOR_FAILED,
  };
}

export function createSent() {
  return { type: CREATE_LESSON_REVIEW_SENT };
}

export function createSucceeded(data) {
  return {
    type: CREATE_LESSON_REVIEW_SUCCEEDED,
    payload: data,
  };
}

export function createFailed(error) {
  return { type: CREATE_LESSON_REVIEW_FAILED };
}

export function fetchByTutor(tutorId, page = 1) {
  return (dispatch) => {
    dispatch(fetchByTutorSent());
    return LessonReviewApiUtils.fetchByTutor(tutorId, page).then(
      (data) => dispatch(fetchByTutorSucceeded(data)),
      (error) => dispatch(fetchByTutorFailed(error)),
    );
  };
}

export function create(lessonId, audio, total, review) {
  return (dispatch) => {
    dispatch(createSent());
    return LessonReviewApiUtils.create(lessonId, audio, total, review).then(
      (data) => {
        dispatch(createSucceeded(data));
        dispatch(
          addFlashMessage(data.message, {
            autoDisappear: false,
            sticky: true,
            type: 'success',
          }),
        );
        dispatch(hideModal());
      },
      (error) => {
        dispatch(createFailed(error));
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: true,
            type: 'error',
          }),
        );
      },
    );
  };
}
